































// Importing components
import BaseCard from '../../ui/BaseCard.vue';
import BaseAlertList from '../../ui/BaseAlertList.vue';
import TheFormProfile from '../../components/auth/TheFormProfile.vue';
import LayoutApp from '../../layputs/LayoutApp.vue';
// Importing functions
import {getConfirmation} from '../../ts/profile/get-confirmation';
import {validateProfile} from '../../ts/profile/validate-profile';
import {putProfile} from '../../ts/profile/put-profile';
import {getProfile} from '../../ts/profile/get-profile';
// Importing variables
import {ChangesSaved} from '../../ts/variables';

export default {
    name: 'PageEditProfile',
    components: {
        LayoutApp,
        BaseCard,
        BaseAlertList,
        TheFormProfile,
    },
    props: {},
    data() {
        return {
            userData: {},
            errors: [],
            verified: false,
            sent: false,
            success: false,
        };
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
    },
    methods: {
        confirmEmail() {
            getConfirmation().then(() => {
                this.sent = true;
            });
        },
        handleSubmit() {
            this.errors = [];

            validateProfile(this.errors, this.userData);

            if (this.errors.length === 0) {
                putProfile(this.errors, this.userData).then(() => {
                    // Clearing up the fields with the passwords
                    this.userData.old_password = '';
                    this.userData.password = '';
                    this.userData.password_confirmation = '';
                    this.success = true;
                });
            }
        },
    },
    mounted() {
        this.userData = {
            first_name: '', last_name: '', email: '',
            phone: '', old_password: '', password: '',
            password_confirmation: '',
        };
        this.$store.dispatch('setLoadingOn');
        getProfile().then((response) => {
            this.userData = {
                ...this.userData,
                ...response,
            };
            this.verified = this.userData.verified_at === null;
        }).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
